(function () {
  var configNode = document.getElementById('ThemeConfig');
  var config = configNode ? JSON.parse(configNode.textContent) : { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function onScroll(fn) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; fn(); });
    }, { passive: true });
  }

  function observe(selector, threshold, toggle, margin) {
    var targets = document.querySelectorAll(selector);
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      each(targets, function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (toggle) { entry.target.classList.toggle('is-in', entry.isIntersecting); return; }
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: threshold, rootMargin: margin || '0px 0px -8% 0px' });
    each(targets, function (t) { io.observe(t); });
  }

  function splitInto(el, parts, className, delay) {
    el.textContent = '';
    var highlight = (el.getAttribute('data-hl') || '').split(',').filter(Boolean);
    parts.forEach(function (part, i) {
      var span = document.createElement('span');
      span.className = className + (highlight.indexOf(part.replace(/[^A-Za-z]/g, '')) > -1 ? ' hl' : '');
      span.textContent = part;
      span.style.transitionDelay = (i * delay) + 's';
      el.appendChild(span);
      if (className === 'w' && i < parts.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  each(document.querySelectorAll('[data-words]'), function (el) { splitInto(el, el.textContent.trim().split(/\s+/), 'w', 0.07); });
  each(document.querySelectorAll('[data-letters]'), function (el) { splitInto(el, el.textContent.trim().split(''), 'l', 0.09); });
  observe('.reveal, .reveal-stagger', 0.12, false);
  observe('[data-words]', 0.4, false);
  observe('[data-letters]', 0.1, true, '0px');

  var openMenu = null;
  function flyout() { return window.matchMedia('(min-width:761px)').matches; }
  function sizeMenu(menu, panel) {
    var pad = 24;
    if (flyout() && panel.classList.contains('menu-panel--sub')) return;
    menu.style.height = (panel.offsetHeight + pad) + 'px';
  }
  function closeSubs(menu) {
    each(menu.querySelectorAll('.menu-panel--sub'), function (p) { p.classList.remove('is-on'); p.setAttribute('aria-hidden', 'true'); });
    each(menu.querySelectorAll('[data-panel-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    menu.classList.remove('has-sub');
  }
  function resetMenu(menu) {
    closeSubs(menu);
    var rootPanel = menu.querySelector('.menu-panel--root');
    if (rootPanel) sizeMenu(menu, rootPanel);
  }
  function setMenu(button, menu, open) {
    menu.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      menu.style.transition = 'none';
      resetMenu(menu);
      void menu.offsetWidth;
      menu.style.transition = '';
      setTimeout(function () { menu.classList.add('is-shown'); }, 20);
    } else {
      menu.classList.remove('is-shown');
      setTimeout(function () { if (!menu.classList.contains('is-open')) resetMenu(menu); }, 320);
    }
    openMenu = open ? { button: button, menu: menu } : null;
  }
  function openSub(menu, btn) {
    var panel = menu.querySelector('[data-panel="' + btn.getAttribute('data-panel-open') + '"]');
    if (!panel) return;
    closeSubs(menu);
    btn.setAttribute('aria-expanded', 'true');
    panel.style.setProperty('--fly-top', Math.max(0, btn.offsetTop - 12) + 'px');
    panel.classList.add('is-on');
    panel.removeAttribute('aria-hidden');
    menu.classList.add('has-sub');
    sizeMenu(menu, panel);
    var first = panel.querySelector('.menu-back');
    if (first && !flyout()) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
    menu.scrollLeft = 0;
  }
  each(document.querySelectorAll('[data-menu]'), function (menu) {
    var leaveTimer = null;
    each(menu.querySelectorAll('[data-panel-open]'), function (btn) {
      btn.addEventListener('click', function () {
        var panel = menu.querySelector('[data-panel="' + btn.getAttribute('data-panel-open') + '"]');
        if (panel && panel.classList.contains('is-on') && flyout()) { closeSubs(menu); return; }
        openSub(menu, btn);
      });
    });
    each(menu.querySelectorAll('.menu-panel--root .menu-item'), function (item) {
      item.addEventListener('mouseenter', function () {
        if (!flyout()) return;
        clearTimeout(leaveTimer);
        if (item.hasAttribute('data-panel-open')) {
          if (item.getAttribute('aria-expanded') !== 'true') openSub(menu, item);
        } else {
          closeSubs(menu);
        }
      });
    });
    menu.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); });
    menu.addEventListener('mouseleave', function () {
      if (!flyout()) return;
      leaveTimer = setTimeout(function () { closeSubs(menu); }, 180);
    });
    each(menu.querySelectorAll('[data-panel-back]'), function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.menu-panel');
        var opener = menu.querySelector('[data-panel-open="' + panel.getAttribute('data-panel') + '"]');
        panel.classList.remove('is-on');
        panel.setAttribute('aria-hidden', 'true');
        menu.classList.remove('has-sub');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); } }
        menu.scrollLeft = 0;
        sizeMenu(menu, menu.querySelector('.menu-panel--root'));
      });
    });
  });
  function closeMenu() { if (openMenu) setMenu(openMenu.button, openMenu.menu, false); }
  each(document.querySelectorAll('[data-dropdown]'), function (button) {
    var menu = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu) return;
    button.addEventListener('click', function () {
      var wasOpen = openMenu && openMenu.menu === menu;
      closeMenu();
      if (!wasOpen) setMenu(button, menu, true);
    });
  });
  document.addEventListener('click', function (e) {
    if (openMenu && !openMenu.menu.contains(e.target) && !openMenu.button.contains(e.target)) closeMenu();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  document.addEventListener('click', function (e) { if (openMenu && e.target.tagName === 'A' && openMenu.menu.contains(e.target)) closeMenu(); });

  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var anchor = document.querySelector('[data-header-anchor]');
    var lastY = window.scrollY;
    var limit = 120;
    function measure() { limit = Math.max(anchor ? anchor.offsetHeight - 120 : 0, 240); }
    measure();
    window.addEventListener('resize', measure);
    onScroll(function () {
      var y = window.scrollY;
      if (y > limit && y < lastY - 2) header.classList.add('is-stuck');
      else if (y <= limit || y > lastY + 2) { header.classList.remove('is-stuck'); closeMenu(); }
      lastY = y;
    });
  }

  function initTypewriter(input) {
    var phrases;
    try { phrases = JSON.parse(input.getAttribute('data-typewriter')); } catch (err) { return; }
    if (!phrases.length || reduceMotion) return;
    var resting = input.getAttribute('placeholder');
    var pIndex = 0, cIndex = 0, deleting = false, timer = null;
    function tick() {
      if (document.hidden) { timer = setTimeout(tick, 1000); return; }
      var phrase = phrases[pIndex];
      cIndex += deleting ? -1 : 1;
      input.setAttribute('placeholder', phrase.slice(0, cIndex) + '|');
      var wait = deleting ? 28 : 55;
      if (!deleting && cIndex === phrase.length) { deleting = true; wait = 1600; }
      else if (deleting && cIndex === 0) { deleting = false; pIndex = (pIndex + 1) % phrases.length; wait = 350; }
      timer = setTimeout(tick, wait);
    }
    input.addEventListener('focus', function () { clearTimeout(timer); input.setAttribute('placeholder', resting); });
    input.addEventListener('blur', function () { if (!input.value) tick(); });
    tick();
  }
  each(document.querySelectorAll('[data-typewriter]'), initTypewriter);

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  each(document.querySelectorAll('[data-validate]'), function (form) {
    form.addEventListener('submit', function (e) {
      var ok = true;
      each(form.querySelectorAll('[required]'), function (input) {
        var field = input.closest('.field') || input.parentNode;
        var value = input.value.trim();
        var valid = value.length > 0 && (input.type !== 'email' || emailPattern.test(value));
        field.classList.toggle('is-error', !valid);
        if (!valid) ok = false;
      });
      if (!ok) e.preventDefault();
    });
    form.addEventListener('input', function (e) {
      var field = e.target.closest('.field');
      if (field) field.classList.remove('is-error');
    });
  });

  each(document.querySelectorAll('[data-autosubmit]'), function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  function bindQty(wrap) {
    var input = wrap.querySelector('input');
    var min = Number(input.min || 0);
    function set(value) {
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { set(Number(input.value) - 1); });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { set(Number(input.value) + 1); });
  }
  each(document.querySelectorAll('[data-qty]'), bindQty);

  function bumpCartCount(delta) {
    each(document.querySelectorAll('[data-cart-count]'), function (el) {
      var next = Number(el.getAttribute('data-count') || 0) + delta;
      el.textContent = next;
      el.setAttribute('data-count', next);
    });
  }

  function addToCart(body) {
    var isForm = typeof FormData !== 'undefined' && body instanceof FormData;
    return fetch(config.routes.cartAdd, {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  var cartLines = null;
  var cartData = null;
  function emit(name) {
    var ev = document.createEvent('Event');
    ev.initEvent(name, true, true);
    document.dispatchEvent(ev);
  }
  function money(cents) {
    var sample = config.strings.currency || '£0.00';
    var symbol = sample.replace(/[\d.,\s]/g, '') || '£';
    return symbol + (cents / 100).toFixed(2);
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderCartPops(cart) {
    each(document.querySelectorAll('[data-cart-pop]'), function (pop) {
      var body = pop.querySelector('[data-cart-pop-body]');
      var count = pop.querySelector('[data-cart-pop-count]');
      var total = pop.querySelector('[data-cart-pop-total]');
      var cta = pop.querySelector('[data-cart-pop-cta]');
      if (!body) return;
      if (count) count.textContent = cart.item_count;
      if (total) total.textContent = money(cart.total_price);
      if (cart.items.length) {
        body.innerHTML = '<ul class="cart-pop__lines">' + cart.items.slice(0, 4).map(function (i) {
          var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2') : '';
          var variant = i.variant_title && i.variant_title !== 'Default Title' ? escapeHtml(i.variant_title) + ' · ' : '';
          return '<li><span class="cart-pop__media">' + (img ? '<img src="' + img + '" alt="" width="120" height="120" loading="lazy">' : '') + '</span><span class="cart-pop__info"><span class="cart-pop__title">' + escapeHtml(i.product_title) + '</span><span class="cart-pop__meta">' + variant + i.quantity + ' × ' + money(i.final_price) + '</span></span><span class="cart-pop__price">' + money(i.final_line_price) + '</span></li>';
        }).join('') + '</ul>';
        if (overweight()) body.innerHTML += '<p class="cart-pop__warn">' + escapeHtml(config.overweight || '') + '</p>';
        if (cta) {
          cta.classList.toggle('is-disabled', overweight());
          cta.textContent = overweight() ? config.overweightShort : config.strings.checkout;
          cta.setAttribute('href', config.routes.cart);
        }
      } else {
        if (cta) cta.classList.remove('is-disabled');
        body.innerHTML = '<p class="cart-pop__empty">' + escapeHtml(config.strings.cartEmpty) + '</p>';
        if (cta) { cta.textContent = config.strings.startShopping; cta.setAttribute('href', config.shopUrl || config.routes.cart); }
      }
    });
  }
  each(document.querySelectorAll('[data-cart-pop]'), function (pop) {
    var link = pop.querySelector('[data-cart-pop-link]');
    var timer;
    function open() { clearTimeout(timer); pop.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); loadCart(); }
    function close() { timer = setTimeout(function () { pop.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 200); }
    pop.addEventListener('mouseenter', open);
    pop.addEventListener('mouseleave', close);
    pop.addEventListener('focusin', open);
    pop.addEventListener('focusout', close);
  });
  function cartWeight() { return cartData && cartData.total_weight ? cartData.total_weight : 0; }
  function overweight() { return cartWeight() > (Number(config.maxWeightKg) || 50) * 1000; }
  function setCart(cart) {
    cartData = cart;
    renderCartPops(cart);
    cartLines = {};
    (cart.items || []).forEach(function (item) { cartLines[item.variant_id] = (cartLines[item.variant_id] || 0) + item.quantity; });
    each(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    emit('chandra:cart');
    return cartLines;
  }
  function loadCart(force) {
    if (cartLines && !force) return Promise.resolve(cartLines);
    return fetch(config.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(setCart);
  }
  function changeCart(variantId, quantity) {
    return fetch(config.routes.cart + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.status) return cart;
      setCart(cart);
      return cart;
    });
  }
  function cartQty(variantId) { return (cartLines && cartLines[variantId]) || 0; }

  each(document.querySelectorAll('[data-bar-search]'), function (wrap) {
    var btn = wrap.querySelector('[data-bar-search-btn]');
    var input = wrap.querySelector('.bar-search__input');
    var closeTimer;
    function open() {
      clearTimeout(closeTimer);
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      input.removeAttribute('tabindex');
    }
    function close() {
      if (input.value || document.activeElement === input) return;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      input.setAttribute('tabindex', '-1');
    }
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 250); });
    btn.addEventListener('click', function () {
      if (wrap.classList.contains('is-open') && input.value) { input.form.submit(); return; }
      open();
      input.focus();
    });
    input.addEventListener('blur', function () { closeTimer = setTimeout(close, 150); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; input.blur(); close(); } });
  });

  function btnState(button, state) {
    button.classList.remove('is-loading', 'is-done');
    if (state) button.classList.add(state);
  }
  function flashAdded(button, label, quantity) {
    btnState(button, 'is-done');
    bumpCartCount(quantity);
    setTimeout(function () {
      btnState(button, '');
      button.classList.add('is-added');
      label.textContent = config.strings.added;
      setTimeout(function () {
        button.classList.remove('is-added');
        label.textContent = config.strings.add;
      }, 1400);
    }, 800);
  }

  window.ChandraTheme = {
    config: config,
    each: each,
    onScroll: onScroll,
    addToCart: addToCart,
    flashAdded: flashAdded,
    btnState: btnState,
    loadCart: loadCart,
    changeCart: changeCart,
    cartQty: cartQty,
    cartWeight: cartWeight,
    overweight: overweight,
    setCart: setCart
  };
})();
